import * as actionTypes from "../actions/ui.actions";

const initialState = {
  snackbarOpen: false,
  snackbarMessage: "",
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SNACKBAR_OPEN:
      return {
        ...state,
        snackbarOpen: true,
        snackbarMessage: action.message,
      };
    case "SNACKBAR_CLEAR":
      return {
        ...state,
        snackbarOpen: false,
      };
    default:
      return state;
  }
};

export default uiReducer;
